import * as React from 'react';
import type { JsonObject } from '@/app-package';
import { ListingDoc } from '@bb/domain/dist/schemas';

import { ListingLabelContext } from 'contexts';
import { formatPrice } from '../../helpers';

type ListingTitleProps = {
  listing: JsonObject<Omit<ListingDoc, 'org' | 'reps'>>;
  extra?: React.ReactNode;
};

const ListingTitle: React.FunctionComponent<ListingTitleProps> = ({
  listing,
  extra,
}) => {
  const { getLabel } = React.useContext(ListingLabelContext);

  return (
    <>
      <div className="col-md-4">
        <strong className="listing-title">
          {listing.line1} {listing.line2}{' '}
        </strong>
        {listing.isHistorical && (
          <h5 style={{ color: 'red' }}>
            {listing.fullReps[0]?.disabled
              ? 'Historical Listing - Agent Disabled'
              : 'Historical Listing'}
          </h5>
        )}
        {extra}
        <h5>
          {listing.city}
          {listing.province && `, ${listing.province}`}
          {listing.postal_code && `, ${listing.postal_code}`}
        </h5>
      </div>
      <div className="col-md-2 listing-title-pricing">
        <span className="listing-title-status">{getLabel(listing.status)}</span>
        <strong className="listing-title-pricing-price">
          {formatPrice(listing.list_price, listing.type)}
        </strong>
        <br />
        {listing.sold_details && listing.availability === 'Sold' && (
          <small className="text-success">
            Sold:
            {formatPrice(listing.sold_details.price, listing.type)}
          </small>
        )}
        {listing.leased_details && listing.availability === 'Leased' && (
          <small className="text-success">
            Leased:
            {formatPrice(listing.leased_details.price, listing.type)}
          </small>
        )}
      </div>
    </>
  );
};

export default ListingTitle;
